import { AUTH_API_URL, fmhAPI } from 'api/APIBase';

export interface FmhToken {
    access_token: string;
    permissions: string[];
    restricted_access: boolean;
    role_name: string;
    npi?: string;
    segment_ids: string[];
}

/** Gets FMH token using Auth0 access token */
export async function getFmhToken({ accessToken }: { accessToken: string }) {
    const url = `${AUTH_API_URL}/access_tokens/`;
    return fmhAPI.base.auth(`Bearer ${accessToken}`).url(url).get().json<FmhToken>();
}
